import type { useSingleton } from "@tippyjs/react";
import { TimerButton } from "@/interface/HeaderBar/RightBar/Timer/TimerButton";
import { TimerWindow } from "@/interface/HeaderBar/RightBar/Timer/TimerWindow";
import { useTimer } from "./useTime";

type TimerProps = {
    singletoneTarget: ReturnType<typeof useSingleton>[1];
    className?: string;
    isActive?: boolean;
};

export const Timer = ({ singletoneTarget, className, isActive }: TimerProps) => {
    const {
        status,
        min,
        sec,
        runPause,
        plusMin,
        openCloseTimerWindow,
        stop,
        handleInputChange,
        handleBlur,
        handleFocus,
        isReadOnlyInput,
    } = useTimer();

    return (
        <>
            <TimerButton
                className={className}
                singletoneTarget={singletoneTarget}
                isTimerRunning={status === "run"}
                timerTime={`${min}:${sec}`}
                isTimerActive={status === "run" || !!isActive}
            />
            {isActive && (
                <TimerWindow
                    runPause={runPause}
                    addTime={plusMin}
                    onClose={openCloseTimerWindow}
                    stop={stop}
                    onInputChange={handleInputChange}
                    onBlur={handleBlur}
                    onFocus={handleFocus}
                    status={status}
                    min={min}
                    sec={sec}
                    readonly={isReadOnlyInput}
                />
            )}
        </>
    );
};
